
import { AppFilter } from "app/models/app-filter.model";
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbListaConvidados extends AppService {

  abstract getListasConvidadosFilter(filter: AppFilter): Observable<any>;
  abstract salvarListaConvidados(entity);
  abstract getListaConvidados(id);
  abstract deleteListaConvidados(id);
  abstract deleteVisitanteListaConvidados(id);
}
